import { create } from 'zustand'

// Phase 1.5: SPA auth is bridged to Devise session cookies. The Rails
// layout emits <meta name="current-user-..."> tags on every render when
// the user is signed in; we read them at boot. There is no token
// management on the client — the browser's session cookie is all the API
// needs to authenticate (Rails handles CSRF via the csrf-token meta).
//
// The store keeps the same shape (`isAuthenticated()`, `currentPerson`,
// `clearSession()`) that the rest of the SPA already uses, so component
// call sites don't have to change.

function readMeta(name) {
  if (typeof document === 'undefined') return null
  const el = document.querySelector(`meta[name="${name}"]`)
  return el ? el.getAttribute('content') : null
}

function readBoolMeta(name) {
  const value = readMeta(name)
  return value === 'true'
}

function bootstrapUser() {
  const id = readMeta('current-user-id')
  if (!id) return null
  return {
    id: Number(id),
    email: readMeta('current-user-email'),
    full_name: readMeta('current-user-name'),
    role: readMeta('current-user-role'),
    is_admin: readBoolMeta('current-user-is-admin'),
  }
}

export const useAuthStore = create((set, get) => ({
  currentPerson: bootstrapUser(),

  isAuthenticated: () => get().currentPerson != null,

  isAdmin: () => Boolean(get().currentPerson?.is_admin),

  // Kept for backward compatibility with older callers — accepts a
  // payload and stores whatever fields it can interpret as a user.
  setSession: (payload) => {
    const person = payload?.person || payload?.user || payload || null
    set({ currentPerson: person })
  },

  // Devise sign-out is handled by the server (DELETE /users/sign_out).
  // This just nukes the in-memory copy so the SPA reflects the change
  // immediately after the redirect.
  clearSession: () => set({ currentPerson: null }),
}))
